import { Link } from "react-router-dom";
import { useCompare } from "@/context/CompareContext";

export default function RecentlyComparedSection() {
  const { compareHistory, isInCompare, toggleCompare, canAdd } = useCompare();

  // Only show history items NOT already in the active compare tray
  const suggestions = compareHistory.filter((p) => !isInCompare(p.id)).slice(0, 3);

  if (suggestions.length === 0) return null;

  return (
    <div className="mt-6 pt-6 border-t border-gray-100">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-history-line text-amber-500 text-sm"></i>
          </div>
          <p className="text-sm font-bold text-gray-800">Recently Compared</p>
        </div>
        <Link
          to="/compare"
          className="text-xs text-amber-500 hover:text-amber-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          View Compare Page →
        </Link>
      </div>

      <div className="flex flex-col gap-2">
        {suggestions.map((product) => {
          const inCompare = isInCompare(product.id);
          const disabled = !inCompare && !canAdd;

          return (
            <div
              key={product.id}
              className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-2.5 transition-colors hover:bg-gray-100/70"
            >
              {/* Thumbnail */}
              <div className="w-10 h-10 rounded-lg overflow-hidden bg-white border border-gray-100 shrink-0 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain p-0.5"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <Link
                  to={`/shop/${product.id}`}
                  className="text-xs font-semibold text-gray-800 hover:text-amber-600 transition-colors line-clamp-1 cursor-pointer"
                >
                  {product.name}
                </Link>
                <p className="text-xs text-gray-400 mt-0.5">
                  <span className="font-bold text-gray-600">${product.price.toLocaleString()}</span>
                  {" · "}
                  <span>{product.brand}</span>
                </p>
              </div>

              {/* Quick-add button */}
              <button
                onClick={() => !disabled && toggleCompare(product)}
                disabled={disabled}
                className={`shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all whitespace-nowrap ${
                  inCompare
                    ? "bg-amber-100 text-amber-700 border border-amber-200 cursor-pointer"
                    : disabled
                    ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                    : "bg-white border border-gray-200 text-gray-600 hover:border-amber-300 hover:text-amber-600 cursor-pointer"
                }`}
              >
                <span className="flex items-center gap-1">
                  <i className={`text-xs ${inCompare ? "ri-check-line" : "ri-add-line"}`}></i>
                  {inCompare ? "In Compare" : disabled ? "Tray Full" : "Compare"}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
